import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, Observable, map, shareReplay } from 'rxjs';
import { LocaleService } from './locale.service';
import { combineLatest } from 'rxjs';
import { Currency } from './services/api/api.service';
import { HttpParams } from '@angular/common/http';
import { DateHelper } from './date-helper';
import { isPlatformBrowser } from '@angular/common';

export interface HostelSearchParams {
  checkInDate?: string;
  checkOutDate?: string;
  noOfGuests?: number;
  cityId?: string;
  currency?: any;
}

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  constructor(
    private localeService: LocaleService,
    @Inject(PLATFORM_ID) private platformId: string
  ) {}

  private searchParams = new BehaviorSubject<HostelSearchParams>({});
  public searchParams$: Observable<HostelSearchParams> = combineLatest([
    this.localeService.currentCurrency,
    this.searchParams,
  ]).pipe(
    // map(([locale, params]: [LocaleInfo, {[key: string]: any}]) => {
    // map((locale: LocaleInfo, params: {[key: string]: any}) => {
    map(([currency, params]) => {
      let presentParams: { [key: string]: any } = {};
      for (const p in params) {
        if ((<any>params)[p]) {
          presentParams[p] = (<any>params)[p];
        }
      }

      if (!presentParams['currency']) {
        presentParams['currency'] = currency.code;
      }

      if (!presentParams['checkInDate']) {
        let start;
        if (this.getParamValueQueryString('checkInDate')) {
          start = new Date(this.getParamValueQueryString('checkInDate')!);
        } else {
          start = new Date();
        }
        const checkInDate = DateHelper.normalizeDateToUTC(start);
        const tomorrow = new Date(checkInDate);
        // tomorrow.setHours(0);
        tomorrow.setDate(tomorrow.getDate());
        presentParams['checkInDate'] = DateHelper.formatDate(tomorrow);
      }

      if (!presentParams['checkOutDate']) {
        let end;
        if (this.getParamValueQueryString('checkOutDate')) {
          end = new Date(this.getParamValueQueryString('checkOutDate'));
          console.log('STRING BEING TURNED INTO DATE:', this.getParamValueQueryString('checkOutDate'));
          presentParams['checkOutDate'] = DateHelper.formatDate(end);
        } else {
          end = new Date(presentParams['checkInDate']);
          console.log('STRING BEING TURNED INTO DATE:', presentParams['checkInDate']);
          const threeDaysAfterCheckIn = new Date(end);
          threeDaysAfterCheckIn.setDate(threeDaysAfterCheckIn.getDate() + 1);
          presentParams['checkOutDate'] = DateHelper.formatDate(
            threeDaysAfterCheckIn
          );
        }
      }

      if (!presentParams['noOfGuests']) {
        presentParams['noOfGuests'] = 1;
      }

      return presentParams;
    }),
    shareReplay({ bufferSize: 1, refCount: false })
  );

  public setSearchParam(key: keyof HostelSearchParams, value: string | number | Date) {
    let val = value;
    if (key === 'checkInDate' || key === 'checkOutDate') {
      if (typeof value === 'string' && !value.match(/^\d{4}-\d{2}-\d{2}$/)) {
        val = DateHelper.normalizeDateToUTC(new Date(value))
          .toISOString()
          .slice(0, 10);
      } else if (value instanceof Date) {
        val = DateHelper.formatDateToLocalString(value);
      }
    }
    this.searchParams.next({ ...this.searchParams.getValue(), [key]: val });
  }

  public calculateNights(startDate: string, endDate: string): number {
    const startIso = new Date(startDate);
    const endIso = new Date(endDate);

    const timeDifference = endIso.getTime() - startIso.getTime();

    return timeDifference / (1000 * 3600 * 24);
  }

  private getParamValueQueryString(paramName: string): string | null | undefined {
    if (isPlatformBrowser(this.platformId)) {
      const url = window.location.href;
      let paramValue;
      if (url.includes('?')) {
        const httpParams = new HttpParams({ fromString: url.split('?')[1] });
        paramValue = httpParams.get(paramName);
      }
      return paramValue;
    }

    return null;
  }
}
